import Locale from "@/helper/locale/Locale.js";

export function useLocale() {
    let lbl = Locale.getLbl()
    let localeCode = Locale.getLocaleCode()

    /**
     * @param {number} locale locale code | th: 1054, en: 1033
     */
    const switchLang = (locale) => {
        if (localeCode == locale) {
            return;
        }

        Locale.setLocale(locale);
        lbl = Locale.getLbl();
        localeCode = Locale.getLocaleCode();
    };

    return {
        lbl,
        localeCode,
        switchLang,
    }
}
